__turbopack_context__.v({
  "NoIcon": "NoResults-module-scss-module__SWLDkG__NoIcon",
  "NoResults": "NoResults-module-scss-module__SWLDkG__NoResults",
  "NoResultsClear": "NoResults-module-scss-module__SWLDkG__NoResultsClear",
  "NoResultsCopy": "NoResults-module-scss-module__SWLDkG__NoResultsCopy",
  "NoResultsIcon": "NoResults-module-scss-module__SWLDkG__NoResultsIcon",
});
